import axios from "axios";
import Stackorder from "@/classes/Stack/StackOrder";
const BASE_URL = "/admin/stackorders";
const getStackOrders = async () => {
    const result = await axios.get(`${BASE_URL}`);
    return result.data.map((stackOrder) => new Stackorder(stackOrder));
};
const createStackOrder = async (stackorder) => {
    return await axios.post(`${BASE_URL}`, stackorder);
};
const updateStackOrder = async (stackorder, stackorderId) => {
    return await axios.put(`${BASE_URL}/${stackorderId}`, stackorder);
};
const deleteStackOrder = async (stackorderId) => {
    return await axios.delete(`${BASE_URL}/${stackorderId}`);
};
export { getStackOrders, createStackOrder, updateStackOrder, deleteStackOrder };
